// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 524 ? "app" : chunkId) + "." + {"489":"69540e09e73ff62c20ec","524":"951782895a9dcb517a57","927":"ab2e6e3a8c955577c444"}[chunkId] + ".css";
};